module.exports = __webpack_public_path__ + "assets/img/11-1.45d21405.png";